module.exports = __webpack_public_path__ + "img/Fragile Things.e268aa3b.svg";